import React, { useEffect } from 'react';
import '../styles.scss';
import '../../uploader/styles.scss';
import { AssetLabRouter } from '../../router/AssetLabRouter';
import { useSelector } from 'react-redux';
import { getInitialized, getMagicStudioEnabled } from '../selectors';
import * as lastStateActions from '../../lastState/actions';
import { parseLocationStateId } from '../../lastState/model';
import { useDispatch } from 'react-redux';
import { MagicStudioModal } from '../../magicStudio/components/MagicStudioModal';
import { MagicBasketTray } from '../../magicStudio/components/MagicBasketTray';

export function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fn = () =>
      dispatch(
        lastStateActions.popState({ url: window.location.href, state_id: parseLocationStateId() }),
      );
    window.addEventListener('popstate', fn);
    return () => window.removeEventListener('popstate', fn);
  });

  const initialized = useSelector(getInitialized);
  // Read before the early return — hooks must run unconditionally.
  const magicStudioEnabled = useSelector(getMagicStudioEnabled);
  if (!initialized) {
    return null;
  }

  return (
    <>
      <AssetLabRouter />
      {/* Mounted once at the app root. The floating basket tray is the single
          entry point into the studio; the modal is opened from it (or from the
          per-asset "Add to Magic Studio" toggles that stage into the basket).
          Gated behind the instance flag `magic_studio_enabled` combined with the
          frontend kill-switch (see app/selectors.getMagicStudioEnabled). */}
      {magicStudioEnabled && (
        <>
          <MagicBasketTray />
          <MagicStudioModal />
        </>
      )}
    </>
  );
}
